import { FormControl, FormLabel, FormHelperText, Input } from '@chakra-ui/react';
import { useCampaignUI } from './ui';
export function TimeField({ label, ariaLabel, help, value, onChange, isDisabled, ...props }) {
 const ui = useCampaignUI();
 return <FormControl {...props}>{label && <FormLabel fontSize='sm' color={ui.textSecondary}>{label}</FormLabel>}
  <Input type='time' step={60} value={value ?? ''} onChange={(event) => onChange?.(event.target.value)}
   aria-label={ariaLabel ?? label ?? 'Time'} isDisabled={isDisabled} sx={{ colorScheme: ui.mode }} bg={ui.inputBg} borderColor={ui.border} color={ui.textPrimary} size='sm'  />
  {help && <FormHelperText color={ui.textMuted}>{help}</FormHelperText>}
 </FormControl>;
}
